"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiredRaiders = void 0;
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
const MonsInsuranceBot_1 = require("../automa/MonsInsuranceBot");
class HiredRaiders extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.HIRED_RAIDERS,
            cost: 1,
            metadata: {
                cardNumber: '124',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.text('steal', Size_1.Size.MEDIUM, true).steel(2).any.br;
                    b.or().br;
                    b.text('steal', Size_1.Size.MEDIUM, true).megacredits(3).any;
                }),
                description: 'Steal up to 2 steel, or 3 M€ from any player.',
            },
        });
    }
    play(player) {
        var _a;
        if (player.game.isSoloMode()) {
            if (((_a = player.game.automaBotCorporation) === null || _a === void 0 ? void 0 : _a.name) === CardName_1.CardName.MONS_INSURANCE_BOT) {
                MonsInsuranceBot_1.MonsInsuranceBot.resolveMonsInsuranceBot(player);
            }
            return new OrOptions_1.OrOptions(new SelectOption_1.SelectOption('Steal 2 steel', 'Steal steel', () => {
                player.steel += 2;
                return undefined;
            }), new SelectOption_1.SelectOption('Steal 3 M€', 'Steal M€', () => {
                player.megaCredits += 3;
                return undefined;
            }));
        }
        const availablePlayerTargets = player.game.getPlayers().filter((p) => p.id !== player.id);
        const availableActions = new OrOptions_1.OrOptions();
        availablePlayerTargets.forEach((target) => {
            if (target.steel > 0 && !target.alloysAreProtected()) {
                const amountStolen = Math.min(2, target.steel);
                const optionTitle = 'Steal ' + amountStolen + ' steel from ' + target.name;
                availableActions.options.push(new SelectOption_1.SelectOption(optionTitle, 'Confirm', () => {
                    player.steel += amountStolen;
                    target.deductResource(Resources_1.Resources.STEEL, 2, { log: true, from: player });
                    return undefined;
                }));
            }
            if (target.megaCredits > 0) {
                const amountStolen = Math.min(3, target.megaCredits);
                const optionTitle = 'Steal ' + amountStolen + ' M€ from ' + target.name;
                availableActions.options.push(new SelectOption_1.SelectOption(optionTitle, 'Confirm', () => {
                    player.megaCredits += amountStolen;
                    target.deductResource(Resources_1.Resources.MEGACREDITS, 3, { log: true, from: player });
                    return undefined;
                }));
            }
        });
        if (availableActions.options.length > 0) {
            availableActions.options.push(new SelectOption_1.SelectOption('Do not steal', 'Confirm', () => {
                return undefined;
            }));
            return availableActions;
        }
        return undefined;
    }
}
exports.HiredRaiders = HiredRaiders;
//# sourceMappingURL=HiredRaiders.js.map